import {NgModule} from '@angular/core';
import {EmConfigPage} from "./page/overview/em-config/em-config.page";
import {
    EmSchemaObjectComponent
} from "./component/object-components/object-component/em-schema-object-component/em-schema-object.component";
import {
    EmSchemaObjectFullComponent
} from "./component/object-components/object-component/em-schema-object-component/view/em-schema-object-component-full/em-schema-object-full.component";
import {
    EmSchemaObjectSideComponent
} from "./component/object-components/object-component/em-schema-object-component/view/em-schema-object-component-side/em-schema-object-side.component";
import {
    EmSchemaObjectBaseComponent
} from "./component/object-components/object-component/em-schema-object-component/view/em-schema-object-base.component";
import {
    SchemaRuntimeComponent
} from "./component/object-components/object-component/em-schema-object-component/view/shared/schema-runtime-component/schema-runtime.component";
import {
    SchemaNodeComponent
} from "./component/object-components/object-component/em-schema-object-component/view/shared/schema-node-component/schema-node.component";
import {
    SchemaStructureComponent
} from "./component/object-components/object-component/em-schema-object-component/view/shared/schema-structure-component/schema-structure.component";
import {
    EmSchemaEditorComponent
} from "./component/object-components/object-component/em-schema-object-component/view/shared/em-schema-editor/em-schema-editor.component";
import {
    EmSchemaTreeComponent
} from "./component/object-components/object-component/em-schema-object-component/view/shared/em-schema-editor/em-schema-tree/em-schema-tree.component";
import {
    EmSchemaCanvasComponent
} from "./component/object-components/object-component/em-schema-object-component/view/shared/em-schema-editor/em-schema-canvas/em-schema-canvas.component";
import {
    EmSchemaDetailPanelComponent
} from "./component/object-components/object-component/em-schema-object-component/view/shared/em-schema-editor/em-schema-detail-panel/em-schema-detail-panel.component";
import {
    EmFieldValuesComponent
} from "./component/object-components/object-component/em-schema-object-component/view/shared/em-schema-editor/em-field-values/em-field-values.component";
import {
    EmAiSchemaDialogComponent
} from "./component/protected-components/em-ai-schema-dialog/em-ai-schema-dialog.component";
import {
    SchemaRuntimeOptimizedComponent
} from "./component/object-components/object-component/em-schema-object-component/view/shared/schema-runtime-optimized/schema-runtime-optimized.component";
import {
    EmSchemaObjectRuntimeDataViewComponent
} from "./component/object-components/object-component/em-schema-object-component/view/shared/em-schema-object-runtime-data-view/em-schema-object-runtime-data-view.component";
import {
    EmRuntimeCacheTriggerComponent
} from "./component/shared/runtime-cache-trigger/em-runtime-cache-trigger.component";
import {
    EmRuntimeCacheProgressComponent
} from "./component/shared/runtime-cache-progress/em-runtime-cache-progress.component";
import {
    EmRuntimeSearchComponent
} from "./component/shared/runtime-search/em-runtime-search.component";
import {EM_ENTITY_PROVIDER} from "./em.entity-provider";
import {CoreModule} from "../../core/core.module";
import {EM_TEST_PROVIDERS} from "./test/em-test-definition";
// PrimeNG-Module, die vom EM-Schema-Workbench (Canvas ↔ Tree + Virtual-Scroller)
// benötigt werden. ScrollerModule registriert den `p-virtualScroller`-Selector
// (seit PrimeNG v20 umbenannt, Selektor bleibt rückwärtskompatibel). Die
// übrigen Module kommen zwar über CoreModule → SharedModule transitiv, werden
// hier aber noch einmal explizit importiert, um lokale Kompilier-Sicherheit
// zu gewährleisten.
import {TreeModule} from "primeng/tree";
import {BadgeModule} from "primeng/badge";
import {ScrollerModule} from "primeng/scroller";
import {SelectButtonModule} from "primeng/selectbutton";
import {MessageModule} from "primeng/message";
import {FormsModule} from "@angular/forms";


@NgModule({
  declarations: [
      EmConfigPage,
    EmSchemaObjectComponent,
    EmSchemaObjectFullComponent,
    EmSchemaObjectSideComponent,
    EmSchemaObjectBaseComponent,
    SchemaRuntimeComponent,
    SchemaNodeComponent,
    SchemaStructureComponent,
    EmSchemaEditorComponent,
    EmSchemaTreeComponent,
    EmSchemaCanvasComponent,
    EmSchemaDetailPanelComponent,
    EmFieldValuesComponent,
    EmAiSchemaDialogComponent,
    SchemaRuntimeOptimizedComponent,
    EmSchemaObjectRuntimeDataViewComponent,
    EmRuntimeCacheTriggerComponent,
    EmRuntimeCacheProgressComponent,
    EmRuntimeSearchComponent,
  ],
  exports:[
    EmConfigPage,
    EmSchemaObjectComponent,
    EmSchemaObjectFullComponent,
    EmSchemaObjectSideComponent,
    EmSchemaObjectBaseComponent,
    SchemaRuntimeComponent,
    SchemaNodeComponent,
    SchemaStructureComponent,
    EmSchemaEditorComponent,
    EmSchemaTreeComponent,
    EmSchemaCanvasComponent,
    EmSchemaDetailPanelComponent,
    EmFieldValuesComponent,
    EmAiSchemaDialogComponent,
    SchemaRuntimeOptimizedComponent,
    EmSchemaObjectRuntimeDataViewComponent,
    EmRuntimeCacheTriggerComponent,
    EmRuntimeCacheProgressComponent,
    EmRuntimeSearchComponent,
  ],
  imports: [
    CoreModule,
    FormsModule,
    TreeModule,
    BadgeModule,
    ScrollerModule,
    SelectButtonModule,
    MessageModule,
  ],
  providers: [EM_ENTITY_PROVIDER, EM_TEST_PROVIDERS]
})
export class EmModule { }